import { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import Swiper from 'swiper'

import { PresentationType, SlideType } from '../../_types'

import { Jumbotron } from './Jumbotron'
import { PresentationControlPanel } from './PresentationControllers'
import { CarouselSlideSelector } from './SlideSelectors'

import './Presentation.css'

export interface PresentationProps extends PresentationType {
  slides: SlideType[]
  pdfURL: string
  pptURL: string
  pptxURL: string
  slidesPerView?: number
  activeIndex: number
  allowTouchMove?: boolean
  onSlideSelect: any
  onSelectNext: any
  onSelectPrev: any
  isMobile?: boolean
  isLandscape?: boolean
}
export const Presentation: React.FC<PresentationProps> = ({
  slides,
  pdfURL,
  pptURL,
  pptxURL,
  slidesPerView,
  activeIndex,
  allowTouchMove = false,
  onSlideSelect,
  onSelectNext,
  onSelectPrev,
  isMobile,
  isLandscape,
}) => {
  const [jumbotron, updateJumbotron] = useState(null as unknown as Swiper)
  const [slideSelector, updateSlideSelector] = useState(
    null as unknown as Swiper
  )

  useEffect(() => {
    if (slideSelector?.activeIndex !== activeIndex) {
      slideSelector?.slideTo(activeIndex, slideSelector?.params?.speed || 300)
      if (
        typeof slideSelector?.params?.slidesPerView === 'number' &&
        (activeIndex < jumbotron?.activeIndex ||
          activeIndex >
            jumbotron?.activeIndex + slideSelector?.params?.slidesPerView + 1)
      ) {
        jumbotron?.slideTo(activeIndex, jumbotron?.params?.speed || 300)
      }
    }
    jumbotron?.slideTo(activeIndex, jumbotron?.params?.speed || 300)
  }, [jumbotron, slideSelector, activeIndex])

  const handleSelectNext = () => {
    if (activeIndex < slides?.length - 1) {
      onSelectNext()
    }
  }
  const handleSelectPrev = () => {
    if (activeIndex > 0) {
      onSelectPrev()
    }
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        userSelect: 'none',
      }}
    >
      <Jumbotron
        slides={slides}
        activeIndex={activeIndex}
        onSliderUpdates={updateSlideSelector}
        onSelectNext={handleSelectNext}
        onSelectPrev={handleSelectPrev}
        allowTouchMove={allowTouchMove}
        isMobile={isMobile}
        isLandscape={isLandscape}
      />
      <PresentationControlPanel
        swiper={slideSelector}
        pdfURL={pdfURL}
        pptURL={pptURL}
        pptxURL={pptxURL}
        activeIndex={activeIndex}
        onSelectNext={handleSelectNext}
        onSelectPrev={handleSelectPrev}
      />
      <CarouselSlideSelector
        slides={slides}
        slidesPerView={slidesPerView}
        onSwiper={updateJumbotron}
        activeIndex={activeIndex}
        onSlideSelect={onSlideSelect}
      />
    </Box>
  )
}

export default Presentation
